import script from "./WorkScheduleView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkScheduleView.vue?vue&type=script&setup=true&lang=ts"

import "./WorkScheduleView.vue?vue&type=style&index=0&id=4d36c172&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d36c172"]])

export default __exports__